"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _guacWidgetCore = require("@wsb/guac-widget-core");

var _dateTimeFormatter = require("../../constants/propTypes/dateTimeFormatter");

var _AvailableTimesPeriod = _interopRequireDefault(require("./AvailableTimesPeriod"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AvailableTimes = function AvailableTimes(_ref) {
  var groupedAvailableTimes = _ref.groupedAvailableTimes,
      onAvailableTimeClick = _ref.onAvailableTimeClick,
      onExpandClick = _ref.onExpandClick,
      i18n = _ref.i18n,
      isMoreTimesHidden = _ref.isMoreTimesHidden,
      dateTimeFormatter = _ref.dateTimeFormatter,
      isoSelectedAvailableTime = _ref.isoSelectedAvailableTime;
  var Block = _guacWidgetCore.UX2.Element.Block;
  var columnCount = 0;

  for (var propt in groupedAvailableTimes) {
    if (groupedAvailableTimes[propt].length > 0) {
      columnCount += 1;
    }
  }

  var styles = {
    grid: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginHorizontal: '-2px',
      marginBottom: '0'
    },
    cell: {
      'flexGrow': '1',
      'flexShrink': '1',
      'paddingHorizontal': 'xxsmall',
      'paddingBottom': 'xlarge',
      '@xs': {
        flexBasis: '100%',
        maxWidth: '100%'
      },
      '@sm': {
        flexBasis: columnCount === 3 ? '33.33333333333333%' : '50%',
        maxWidth: columnCount === 3 ? '33.33333333333333%' : '50%',
        marginLeft: columnCount === 1 ? '25%' : '0'
      }
    }
  };
  return /*#__PURE__*/_react["default"].createElement(Block, {
    style: styles.grid
  }, Object.keys(groupedAvailableTimes).map(function (period, index) {
    var periodAvailableTimes = groupedAvailableTimes[period]; // Don't render column if availableTimes is empty.

    return periodAvailableTimes.length ? /*#__PURE__*/_react["default"].createElement(Block, {
      key: index,
      style: styles.cell
    }, /*#__PURE__*/_react["default"].createElement(_AvailableTimesPeriod["default"], {
      period: period,
      periodAvailableTimes: periodAvailableTimes,
      onAvailableTimeClick: onAvailableTimeClick,
      onExpandClick: onExpandClick,
      i18n: i18n,
      isMoreTimesHidden: isMoreTimesHidden,
      dateTimeFormatter: dateTimeFormatter,
      isoSelectedAvailableTime: isoSelectedAvailableTime
    })) : null;
  }));
};

AvailableTimes.propTypes = {
  dateTimeFormatter: _dateTimeFormatter.dateTimeFormatterPropType.isRequired,
  groupedAvailableTimes: _propTypes["default"].object.isRequired,
  onAvailableTimeClick: _propTypes["default"].func.isRequired,
  onExpandClick: _propTypes["default"].func.isRequired,
  i18n: _propTypes["default"].object.isRequired,
  isMoreTimesHidden: _propTypes["default"].object.isRequired,
  isoSelectedAvailableTime: _propTypes["default"].string
};
var _default = AvailableTimes;
exports["default"] = _default;